export const BilanOptions = {
  Bilan: {
    id: 1,
    module: "Bilan",
    sous_module: "Bilan",
    parametre: {

    nombre_cible: [
      { value: "192", label: "192 cibles" },
      { value: "384", label: "384 cibles" },
      { value: "576", label: "576 cibles" },
    ],
  }},
  instructions:
    "Fixez bien la croix au centre de l’écran sans bouger les yeux. Votre objectif est de pointer du doigt toutes les cibles que vous pourrez percevoir tout en maintenant la fixation au centre. Une fois une cible pointée, laissez votre doigt sur l’écran et vérifiez en regardant. Prenez autant de temps que nécessaire et n’hésitez pas à pointer à nouveau les cibles manquées en fixant bien à nouveau la croix centrale. Appuyez sur la barre espace pour passer à l’essai suivant. Si vous souhaitez faire une pause ne cours d’exercice, appuyez sur echap. Appuyez sur la barre espace pour lancer l’exercice.",
  Lecture: {
    id: 2,
    module: "Lecture",
    sous_module: "Test de lecture",
    parametre: {
      contenu: [
        { value: "1", label: "Texte 1" },
        { value: "2", label: "Texte 2" },
      ],
    },
  },
  Exploration: {
    id: 3,
    module: "Exploration",
    sous_module: "Test d'exploration",
  },
  };

export const TitreChamp = {
  type_forme: "Forme de la cible",
  taille: "Taille de la cible",
  nombre_par_hemichamp: "Nombre de cible par hémichamp",
  couleur_cible: "Couleur de la cible",
  couleur_fond: "Couleur du fond",
  side: "Latéralisation de la cible",
  mouvement: "Mouvement des cibles",
  vitesse: "Vitesse du défilement",
  temps: "Durée de l'exercice",
  side_aveugle: "Latéralisation de la lésion",
  nombre_cible: "Nombre de cible",
  contenu: "Contenu de l'exercice",
};
